import {createSvgIcon} from '../create-svg-icon';

export const SkipNextIcon = createSvgIcon(
  <path d="m6 18 8.5-6L6 6v12zm2-8.14L11.03 12 8 14.14V9.86zM16 6h2v12h-2z" />
, 'SkipNextOutlined');
